import React from "react";

function Textarea(props) {
  return (
    <textarea
      {...props}
      className={`border rounded-md px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-400 ${props.className || ""}`}
    />
  );
}

export { Textarea };
export default Textarea;
